import { createContext } from "react";

export const initialSettings = {
  colorPreset: "indigo",
  contrast: "high",
  direction: "ltr",
  layout: "vertical",
  navColor: "evident",
  paletteMode: "light",
  responsiveFontSizes: true,
  stretch: false,
};

export const initialState = {
  ...initialSettings,
  isInitialized: false,
  openDrawer: false,
};

const SettingsContext = createContext({
  ...initialState,
  handleDrawerClose: () => {},
  handleDrawerOpen: () => {},
  handleReset: () => {},
  handleUpdate: () => {},
  isCustom: false,
});

export default SettingsContext;
